module.exports = __webpack_public_path__ + "static/img/order-success.8d351bb1.png";